import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr2007',
    ecrans: ['00-2']
});

